import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
import { applyDefaultThemePreference } from './modules/theme';

// Default to the Golden Hippo dark theme on first load (before the app reads
// the stored theme selection). Runs once; the user's Settings choice overrides.
applyDefaultThemePreference();

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
